import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Price } from '@yonderland/andes-react';
import { usePriceProps } from '../../../hooks/usePriceProps';
export const MiniPDPPrice = ({ color, selectedSize, isOutOfStock }) => {
    const prices = (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.prices) || color.prices;
    const priceProps = usePriceProps({
        priceInformation: {
            prices,
            hasDiscount: color.hasDiscount,
        },
        dynamicSavingsInformation: {
            productDiscountAmount: (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.productDiscountAmount) || color.price.productDiscountAmount,
            productDiscountPercentage: (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.productDiscountPercentage) || color.price.productDiscountPercentage,
        },
    });
    if (!priceProps) {
        return null;
    }
    return (_jsx(Box, { paddingBlockStart: "4", opacity: isOutOfStock ? '50' : undefined, children: _jsx(Price, Object.assign({}, priceProps, { size: "lg" })) }));
};
